"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () { return function (_a) {
    var theme = _a.theme;
    return "background-color: " + theme.palette.inputBg + ";";
}; });
